/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import DatePicker from 'react-widgets/DatePicker';
import * as _ from 'underscore';


function generateTimes() {
    return [
        {value: '', label: ''},
        {value: '00:00', label: '12:00 am'},
        {value: '00:30', label: '12:30 am'},
        {value: '01:00', label: '1:00 am'},
        {value: '01:30', label: '1:30 am'},
        {value: '02:00', label: '2:00 am'},
        {value: '02:30', label: '2:30 am'},
        {value: '03:00', label: '3:00 am'},
        {value: '03:30', label: '3:30 am'},
        {value: '04:00', label: '4:00 am'},
        {value: '04:30', label: '4:30 am'},
        {value: '05:00', label: '5:00 am'},
        {value: '05:30', label: '5:30 am'},
        {value: '06:00', label: '6:00 am'},
        {value: '06:30', label: '6:30 am'},
        {value: '07:00', label: '7:00 am'},
        {value: '07:30', label: '7:30 am'},
        {value: '08:00', label: '8:00 am'},
        {value: '08:30', label: '8:30 am'},
        {value: '09:00', label: '9:00 am'},
        {value: '09:30', label: '9:30 am'},
        {value: '10:00', label: '10:00 am'},
        {value: '10:30', label: '10:30 am'},
        {value: '11:00', label: '11:00 am'},
        {value: '11:30', label: '11:30 am'},
        {value: '12:00', label: '12:00 pm'},
        {value: '12:30', label: '12:30 pm'},
        {value: '13:00', label: '1:00 pm'},
        {value: '13:30', label: '1:30 pm'},
        {value: '14:00', label: '2:00 pm'},
        {value: '14:30', label: '2:30 pm'},
        {value: '15:00', label: '3:00 pm'},
        {value: '15:30', label: '3:30 pm'},
        {value: '16:00', label: '4:00 pm'},
        {value: '16:30', label: '4:30 pm'},
        {value: '17:00', label: '5:00 pm'},
        {value: '17:30', label: '5:30 pm'},
        {value: '18:00', label: '6:00 pm'},
        {value: '18:30', label: '6:30 pm'},
        {value: '19:00', label: '7:00 pm'},
        {value: '19:30', label: '7:30 pm'},
        {value: '20:00', label: '8:00 pm'},
        {value: '20:30', label: '8:30 pm'},
        {value: '21:00', label: '9:00 pm'},
        {value: '21:30', label: '9:30 pm'},
        {value: '22:00', label: '10:00 pm'},
        {value: '22:30', label: '10:30 pm'},
        {value: '23:00', label: '11:00 pm'},
        {value: '23:30', label: '11:30 pm'}
    ];
}

class GMBPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            gmb: {
                postStyle: 0,
                postAction: '',
                url: '',
                redeemOnlineUrl: '',
                couponCode: '',
                termsConditions: '',
                eventTitle: '',
                startTime: [null, null],
                endTime: [null, null]
            }
        };

        this.onUpdateGMBField = this.onUpdateGMBField.bind(this);
        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);
        this.updateDate = this.updateDate.bind(this);
        this.updateTime = this.updateTime.bind(this);

    }

    componentDidMount() {
        let gmb = this.state.gmb;

        if (this.props.posts[0].params.gmb !== undefined) {
            gmb.postAction = (this.props.posts[0].params.gmb.postAction) ? this.props.posts[0].params.gmb.postAction : '';
            gmb.postStyle = (this.props.posts[0].params.gmb.postStyle !== undefined) ? this.props.posts[0].params.gmb.postStyle : 0;
            gmb.url = (this.props.posts[0].params.gmb.url) ? this.props.posts[0].params.gmb.url : '';
            gmb.redeemOnlineUrl = (this.props.posts[0].params.gmb.redeemOnlineUrl) ? this.props.posts[0].params.gmb.redeemOnlineUrl : '';
            gmb.couponCode = (this.props.posts[0].params.gmb.couponCode) ? this.props.posts[0].params.gmb.couponCode : '';
            gmb.termsConditions = (this.props.posts[0].params.gmb.termsConditions) ? this.props.posts[0].params.gmb.termsConditions : '';
            gmb.eventTitle = (this.props.posts[0].params.gmb.eventTitle) ? this.props.posts[0].params.gmb.eventTitle : '';
            gmb.startTime = (this.props.posts[0].params.gmb.startTime) ? this.props.posts[0].params.gmb.startTime : [null, null];
            gmb.endTime = (this.props.posts[0].params.gmb.endTime) ? this.props.posts[0].params.gmb.endTime : [null, null];

            this.setState({
                gmb
            });

        }

    }

    onUpdateGMBField(e) {
        let constants = this.props.app.config.constants,
            gmb = this.state.gmb,
            gmbField = (e.currentTarget.dataset.gmbfield) ? e.currentTarget.dataset.gmbfield : e.currentTarget.dataset.field,
            dataEvent = {
                currentTarget: {
                    dataset: {
                        field: 'posts[0].params.gmb.' + gmbField
                    }
                },
                target: {
                    value: e.currentTarget.value
                }
            };

        if (gmbField === 'postStyle' && parseInt(this.state.gmb.postStyle, 10) !== parseInt(dataEvent.target.value, 10)) {
            switch (parseInt(dataEvent.target.value, 10)) {
                case constants.POST_CTA:
                    gmb = {
                        postStyle: dataEvent.target.value,
                        postAction: constants.ACTION_LEARNMORE,
                        url: '',
                        redeemOnlineUrl: '',
                        couponCode: '',
                        termsConditions: '',
                        eventTitle: '',
                        startTime: [null, null],
                        endTime: [null, null]
                    };
                    break;

                case constants.POST_OFFER:
                case constants.POST_EVENT:
                    gmb = {
                        postStyle: dataEvent.target.value,
                        postAction: '',
                        url: '',
                        redeemOnlineUrl: '',
                        couponCode: '',
                        termsConditions: '',
                        eventTitle: '',
                        startTime: [null, null],
                        endTime: [null, null]
                    };
                    break;

                default:
                    break;

            }

            dataEvent.currentTarget.dataset.field = 'posts[0].params.gmb';
            dataEvent.target.value = gmb;

        } else {
            gmb[gmbField] = e.currentTarget.value;
        }

        this.props.requestChange(dataEvent);

        this.setState({
            gmb
        });

    }

    // the following is a workaround for not being able to access the underlying input
    // through the callback args from react-widgets -- bastards
    updateStartDate(date, string) {

        this.updateDate('startTime', date, string);

    }

    updateEndDate(date, string) {

        this.updateDate('endTime', date, string);

    }

    updateDate(which, date, string) {
        let gmb = this.state.gmb,
            dataEvent = {
                currentTarget: {
                    dataset: {
                        field: 'posts[0].params.gmb.' + which
                    }
                },
                target: {
                    value: ''
                }
            },
            dateValue = '',
            time = (gmb[which][1] !== null) ? gmb[which][1] : null;

        dateValue = moment(date).format("YYYY-MM-DD");

        dataEvent.target.value = [dateValue, time];
        gmb[which] = [dateValue, time];

        this.props.requestChange(dataEvent);

        this.setState({
            gmb
        });

    }

    updateTime(e) {
        let gmb = this.state.gmb,
            field = e.currentTarget.dataset.field,
            date = gmb[field][0] !== null ? gmb[field][0] : null,
            dataEvent = {
                currentTarget: {
                    dataset: {
                        field: 'posts[0].params.gmb.' + field
                    }
                },
                target: {
                    value: [null, null]
                }
            },
            time = e.currentTarget.value ? e.currentTarget.value : null;

        dataEvent.target.value = [date, time];
        gmb[field] = [date, time];

        this.props.requestChange(dataEvent);

        this.setState({
            gmb
        });

    }

    render () {
        let constants = this.props.app.config.constants,
            postTypes = [
                {value: constants.POST_CTA, label: 'Update'},
                {value: constants.POST_EVENT, label: 'Event'},
                {value: constants.POST_OFFER, label: 'Offer'}
            ],
            buttonTypes = [
                {value: '', label: 'No Button'},
                {value: constants.ACTION_LEARNMORE, label: 'Learn more'},
                {value: constants.ACTION_SIGNUP, label: 'Sign up'},
                {value: constants.ACTION_SHOP, label: 'Buy'},
                {value: constants.ACTION_ORDER, label: 'Order online'},
                {value: constants.ACTION_BOOK, label: 'Book'}
            ],
            panelContent = null,
            urlField = null,
            startDate = this.state.gmb.startTime[0],
            startTime = this.state.gmb.startTime[1],
            endDate = this.state.gmb.endTime[0],
            endTime = this.state.gmb.endTime[1],
            times = generateTimes();

        if (startDate !== null) {
            startDate = new Date(startDate + " 00:00:00");
        }

        if (endDate !== null) {
            endDate = new Date(endDate + " 00:00:00");
        }

        if (this.state.gmb.postAction !== '') {
            let label = "Button Link";

            if (parseInt(this.state.gmb.postStyle, 10) === constants.POST_EVENT) {
                label = "Button Link (optional)";
            }

            urlField = (
                <div>
                    <div className="panel-row-label">{label}</div>
                    <UncontrolledTextInput
                        value={this.state.gmb.url}
                        onChange={this.onUpdateGMBField}
                        className="text-input medium"
                        placeholder="https://example.com"
                        data-gmbfield="url"/>
                </div>
            );
        }

        switch (parseInt(this.state.gmb.postStyle, 10)) {
            case constants.POST_CTA:
                panelContent = (
                    <div className="panel-section">
                        <div className="panel-row">
                            <div className="panel-row-label">Button Label</div>
                            <StyledSelect
                                options={buttonTypes}
                                onChange={this.onUpdateGMBField}
                                value={this.state.gmb.postAction}
                                selectClass="large gmb-row"
                                linkedField="postAction"/>
                        </div>
                        <div className="panel-row">
                            {urlField}
                        </div>
                    </div>
                );
                break;

            case constants.POST_EVENT:
                panelContent = (
                    <div className="panel-section gmb-event">
                        <div className="panel-row">
                            <div className="panel-inline">
                                <div className="panel-row-label">Start Date</div>
                                <DatePicker
                                    min={new Date()}
                                    value={startDate}
                                    onChange={this.updateStartDate}
                                    name="startTime"
                                    containerClassName="gmb-picker"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">Start Time (optional)</div>
                                <StyledSelect
                                    options={times}
                                    value={startTime}
                                    onChange={this.updateTime}
                                    selectClass="small gmb-time"
                                    linkedField="startTime"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">End Date</div>
                                <DatePicker
                                    min={new Date()}
                                    value={endDate}
                                    onChange={this.updateEndDate}
                                    name="endTime"
                                    containerClassName="gmb-picker"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">End Time (optional)</div>
                                <StyledSelect
                                    options={times}
                                    value={endTime}
                                    onChange={this.updateTime}
                                    selectClass="small gmb-time"
                                    linkedField="endTime"/>
                            </div>
                        </div>
                        <div className="panel-row">
                            <div className="panel-row-label">Title</div>
                            <UncontrolledTextInput
                                value={this.state.gmb.eventTitle}
                                onChange={this.onUpdateGMBField}
                                data-gmbfield="eventTitle"
                                className="text-input large"
                                placeholder="Example: Sale this week"/>
                        </div>
                        <div className="panel-row">
                            <div className="panel-inline">
                                <div className="panel-row-label">Button Label (optional)</div>
                                <StyledSelect
                                    options={buttonTypes}
                                    onChange={this.onUpdateGMBField}
                                    value={this.state.gmb.postAction}
                                    selectClass="small gmb-row"
                                    linkedField="postAction"/>
                            </div>
                            <div className="panel-inline event-link">
                                {urlField}
                            </div>
                        </div>
                    </div>
                );
                break;

            case constants.POST_OFFER:
                panelContent = (
                    <div className="panel-section gmb-offer">
                        <div className="panel-row">
                            <div className="panel-inline">
                                <div className="panel-row-label">Start Date</div>
                                <DatePicker
                                    includeTime={true}
                                    min={new Date()}
                                    value={startDate}
                                    onChange={this.updateStartDate}
                                    data-gmbfield="startDate"
                                    containerClassName="gmb-picker"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">Start Time (optional)</div>
                                <StyledSelect
                                    options={times}
                                    value={startTime}
                                    onChange={this.updateTime}
                                    selectClass="small gmb-time"
                                    linkedField="startTime"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">End Date</div>
                                <DatePicker
                                    includeTime={true}
                                    min={new Date()}
                                    value={endDate}
                                    onChange={this.updateEndDate}
                                    data-gmbfield="endDate"
                                    containerClassName="gmb-picker"/>
                            </div>
                            <div className="panel-inline">
                                <div className="panel-row-label">End Time (optional)</div>
                                <StyledSelect
                                    options={times}
                                    value={endTime}
                                    onChange={this.updateTime}
                                    selectClass="small gmb-time"
                                    linkedField="endTime"/>
                            </div>
                        </div>
                        <div className="panel-row">
                            <div className="panel-row-label">Title</div>
                            <UncontrolledTextInput
                                value={this.state.gmb.eventTitle}
                                onChange={this.onUpdateGMBField}
                                data-gmbfield="eventTitle"
                                className="text-input large"
                                placeholder="Example: 20% off in store or online"/>
                        </div>
                        <div className="panel-row">
                            <div className="panel-row-label">Coupon Code (optional)</div>
                            <UncontrolledTextInput
                                value={this.state.gmb.couponCode}
                                onChange={this.onUpdateGMBField}
                                data-gmbfield="couponCode"
                                className="text-input large"/>
                        </div>
                        <div className="panel-row">
                            <div className="panel-row-label">Link to redeem offer (optional)</div>
                            <UncontrolledTextInput
                                value={this.state.gmb.redeemOnlineUrl}
                                onChange={this.onUpdateGMBField}
                                data-gmbfield="redeemOnlineUrl"
                                className="text-input large"/>
                        </div>
                        <div className="panel-row">
                            <div className="panel-row-label">Terms and Conditions (optional)</div>
                            <textarea className="gmb-tnc" value={this.state.gmb.termsConditions} data-gmbfield="termsConditions" onChange={this.onUpdateGMBField}></textarea>
                        </div>
                    </div>
                );
                break;

            default:
                break;
        }

        return (
            <div className="panel-content gmb">
                <div className="panel-header gmb">
                    Select a Google Business Profile Post Type:
                    <StyledSelect
                        options={postTypes}
                        onChange={this.onUpdateGMBField}
                        value={this.state.gmb.postStyle}
                        selectClass="small gmb"
                        linkedField="postStyle"/>
                </div>
                {panelContent}
            </div>
        );
    }
}

GMBPanel.propTypes = {
    panels: PropTypes.object,
    post: PropTypes.object,
    requestChange: PropTypes.func,
    activateAccessory: PropTypes.func
};

GMBPanel.defaultProps = {
    panels: {},
    post: {},
    requestChange: null,
    activateAccessory: null
};

export default GMBPanel;
